import { render, staticRenderFns } from "./AceptacionTos.vue?vue&type=template&id=36884c42&scoped=true&"
import script from "./AceptacionTos.vue?vue&type=script&lang=js&"
export * from "./AceptacionTos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36884c42",
  null
  
)

export default component.exports